import { useTranslation } from 'react-i18next';
import useMobile from '@/services/hooks/useMobile';

export const useTableHeaders = () => {
    const isMobile = useMobile();
    const { t } = useTranslation();
    const headerName = [
        { id: 'name', numeric: false, disablePadding: true, label: t('name') },
        { id: 'rule', numeric: false, disablePadding: true, label: t('rule') },
        { id: 'tracking', numeric: true, disablePadding: false, label: t('trackinghistory') },
        { id: 'icons', numeric: true, disablePadding: false, label: '' },
    ];
    const headerNameMobile = [t('rule'), t('trackinghistory')];

    if (isMobile) {
        return headerNameMobile;
    }

    return headerName;
};
